<template>
  <div>
    <input
      :checked="inputChecked"
      type="radio"
      :id="inputId"
      :name="inputName"
      @input="setInput"
      :value="inputValue"
    >
    <label :for="inputId">{{inputLabel}}</label>
  </div>
</template>

<script>
export default {
  props: {
    inputId: String,
    inputName: String,
    inputValue: Boolean | String,
    inputChecked: Boolean,
    inputLabel: String,
    setInput: Function
  }
};
</script>

<style lang="scss" scoped>
  div {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  input[type="radio"] {
    width: 20px;
    height: 20px;
    margin: 0;
    cursor: pointer;
    accent-color: #0066cc;
    flex-shrink: 0;
  }

  label {
    font-size: 18px;
    margin: 0;
    cursor: pointer;
    color: #1a1a1a;
    line-height: 1.4;
  }
</style>

